<template>
  <v-container fluid>
    <!-- Tabella Tipi Segnalazione -->
    <v-data-table
      :headers="headers"
      fixed-header
      :items="items_tipi"
      :items-per-page="10"
      item-key="id_tabella"
      class="elevation-1 mt-5"
      calculate-widths
      height="60vh"
    >
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Tipi di segnalazione
          </v-toolbar-title>
          <v-spacer />
          <!-- Pulsante apri dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-15"
                @click="apriDialog"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
          <v-spacer />
        </v-toolbar>
      </template>
      <!-- Pulsante Modifica -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="
                selectItem(item);
                dialog_crea = true;
              "
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Pulsante eliminazione -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="selectItem(item), (delete_dialog = true)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_crea" persistent max-width="800px">
      <v-card class="pb-10">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Aggiungi </v-toolbar-title>
          <v-spacer />
          <!-- Pulsante salva tipo -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaTipo"
                class="mr-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
          <v-spacer />
          <!-- Pulsante chiudi dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_crea = false"
                class="mr-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-row justify="center" class="mt-5">
          <v-col cols="8">
            <v-text-field
              v-model="selected_item.des"
              label="Tipo"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="selected_item.cod"
              label="Codice"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- Dialog eliminazione Tipo -->
    <v-dialog persistent v-model="delete_dialog" max-width="800px">
      <v-card min-height="150px">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Pulsante conferma -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  selected_item.validita = 0;
                  salvaTipo();
                "
                class="mr-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Pulsante chiudi dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="delete_dialog = false"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <div class="text-center mt-10">
          Sei sicuro di voler eliminare il tipo
          {{ selected_item.des }}
        </div>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
    <script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Segnalazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod", default_val: "" },
      { nome: "des", default_val: "" },
      { nome: "id_tabella", default_val: -1 },
      { nome: "tipo", default_val: "TIPOLOGIA_SEGNALAZIONE" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}
export default {
  name: "QLTipiSegnalazione",

  data() {
    return {
      // Variabili d'appoggio
      dialog_crea: false,
      delete_dialog: false,
      overlay: false,
      selected_item: new Segnalazione(),
      // Array
      items_tipi: [],
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
          width: "100px",
        },
        {
          text: "Tipo",
          value: "des",
          filterable: false,
          sortable: false,
        },
        {
          text: "Codice",
          value: "cod",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  components: { SnackbarQV },
  methods: {
    selectItem(item) {
      this.selected_item = JSON.parse(JSON.stringify(item));
    },
    apriDialog() {
      this.dialog_crea = true;
      this.selected_item = new Segnalazione();
    },
    salvaTipo() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "settabelle",
          id_utente: localStorage.id,
          tabella: [this.selected_item],
          assistenza: 0,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.delete_dialog = false;
          this.dialog_crea = false;
          this.$refs.SnackbarQV.print("success", "Tipo salvato.");
          this.aggiornaItems();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      }).catch((e)=>{
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
      });
    },
    aggiornaItems() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "TIPOLOGIA_SEGNALAZIONE",
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_tipi = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.aggiornaItems();
  },
};
</script>
    <style scoped>
</style>